// extracted by mini-css-extract-plugin
export default {"FolderPath":"MobileFolderName_FolderPath__1uAgO"};